import React from "react";
import { HandleInvoiceStateProvider } from "./Components/HandleInvoiceStateProvider";
import NewPurchaseInvoiceTaxPrime from "./NewPurchaseInvoiceTaxPrime";
import { AccountDetailsProvider } from "./Components/AccountDetailsProvider";
import { SendEmailModalWrapper, useSendEmailModal } from "../../features/Email";


function CreatePurchase({ isVoucher,accountDetails }) {
  // Email modal hook
  const { modalProps } = useSendEmailModal(['purchaseInvoice', 'customer', 'supplier']);
  
  return (
    <AccountDetailsProvider accountDetails={accountDetails}>
    <HandleInvoiceStateProvider>
      <NewPurchaseInvoiceTaxPrime isVoucher={isVoucher}  />
      <SendEmailModalWrapper {...modalProps} />
    </HandleInvoiceStateProvider>
    </AccountDetailsProvider>
  );
}

export default CreatePurchase;
